import React from "react";
import { formatProcedureName } from "utils/formatProcedureName";
import PrimaryButton from "./PrimaryButton";

type PatientInfoSelectFormProps = {
  onSubmit: (selectedValues: string[]) => void;
  selections: string[];
  multiple?: boolean;
};

const PatientInfoSelectForm: React.FC<PatientInfoSelectFormProps> = ({
  onSubmit,
  selections,
  multiple = true,
}) => {
  const [selectedValues, setSelectedValues] = React.useState<string[]>(
    multiple ? [] : [""],
  );
  const [pressSubmit, setPressSubmit] = React.useState<boolean>(false);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (multiple) {
      setSelectedValues((prevSelected) =>
        prevSelected.includes(value)
          ? prevSelected.filter((item) => item !== value)
          : [...prevSelected, value],
      );
    } else {
      setSelectedValues([value]);
    }
  };

  const handleOnPressSubmit = async () => {
    onSubmit(selectedValues); // Pass selected values to the parent on submit
    setPressSubmit(true); // Disable the form after submit
  };

  return (
    <div
      style={{
        gap: 10,
        width: "75%",
        display: "flex",
        borderRadius: 20,
        marginLeft: "auto",
        padding: "10px 20px",
        flexDirection: "column",
        border: "1px solid #C4C6CD",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <fieldset
          style={{
            border: "none",
            padding: 0,
            margin: 0,
            display: "flex",
            flexDirection: "column",
            gap: 5,
          }}
        >
          {selections.map((condition) => (
            <div key={condition}>
              <input
                style={{ marginRight: 5 }}
                type="checkbox"
                id={condition}
                value={condition}
                checked={selectedValues.includes(condition)} // Mark as checked if it's selected
                disabled={pressSubmit} // Disable after submit
                onChange={handleOnChange}
              />
              <label htmlFor={condition}>
                {formatProcedureName(condition)}
              </label>
            </div>
          ))}
        </fieldset>
      </div>
      <PrimaryButton
        text={"Confirm"}
        type="button"
        fullWidth
        useThemeColor={false}
        disabled={pressSubmit || selectedValues.length === 0}
        displayPoweredBy={false}
        onClick={handleOnPressSubmit}
      />
    </div>
  );
};

export default PatientInfoSelectForm;
